export const RQ_GET_PROMOCODE_API = {
  url: 'api/promocode/lookup/all',
  method: 'GET',
  auth: true,
};

export const RQ_PROMOCODE_REGISTER = {
  url: 'api/promocode/register',
  method: 'POST',
  auth: true,
};

export const RQ_UPDATE_PROMOCODE = {
  url: 'api/promocode/<%= id %>/update',
  method: 'PUT',
  auth: true,
};

export const RQ_ACTIVE_PROMOCODE = {
  url: 'api/promocode/lookup/all/active',
  method: 'GET',
  auth: true,
};
export const RQ_PROMOCODE_LOOKUP_BY_ID = {
  url: 'api/promocode/<%= id %>/lookup',
  method: 'GET',
  auth: true,
};

export const RQ_PROMOCODE_Delete = {
  url: 'api/promocode/delete/<%= id %>',
  method: 'DELETE',
  auth: true,
};
